import React, { useCallback, useState } from "react";
import { Box, Typography } from "@material-ui/core";
import { CustomButton, CustomCard } from "../../../../../../../Components";
import { useSelectedTheme } from "../../../../../../../Hooks";
import MatchingCRMUnitsDialog from "../MatchingCRMUnitsDialog/MatchingCRMUnitsDialog";

// Icons
import {
  Announcement03,
  BedIcon,
  EyeIcon,
  UnitSizeIcon,
} from "../../../../../../../assets/icons";

// Styles
import useStyles from "./styles";

const SummaryCard = ({ summaryData }) => {
  const styles = useStyles();
  const {
    theme: { palette },
  } = useSelectedTheme();

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [selectedUnits, setSelectedUnits] = useState([]);

  const handleUnitsClick = useCallback((item) => {
    const units = item.unitReferences || [];
    setSelectedUnits(units);
    setIsDialogOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setIsDialogOpen(false);
    setSelectedUnits([]);
  }, []);

  const formatNumberWithCommas = (number) => {
    if (!number) return "";
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  return (
    <>
      {summaryData?.map((item, index) => (
        <CustomCard
          key={index}
          borderRadius="xl"
          borderColor="secondary"
          classes={styles.card}
        >
          <Box className={styles.container}>
            <Box className={styles.leftSection}>
              <Typography className={styles.typeText}>
                {item?.unitType || "Apartment"}
              </Typography>
              <Box className={styles.saleInfo}>
                <Typography className={styles.saleText}>
                  {item?.operationType || "For Sale"}
                </Typography>
                <BedIcon
                  width={20}
                  height={20}
                  fill={palette.foreground.quinary}
                  style={{ margin: "0 4px 0 12px" }}
                />
                <Typography className={styles.bedsText}>
                  {item?.bedrooms || 0}
                </Typography>
              </Box>
            </Box>

            <Box className={styles.middleSection}>
              <Box className={styles.medianSizeBox}>
                <UnitSizeIcon
                  width={20}
                  height={20}
                  fill={palette.foreground.quinary}
                  style={{ marginRight: 4 }}
                />
                <Typography className={styles.medianText}>
                  Median size&nbsp;
                  <span
                    style={{
                      color: palette.foreground.brandPrimary,
                      fontWeight: 600,
                    }}
                  >
                    <span style={{wordBreak: "break-all", fontSize: 16, display: "inline-block", minWidth: 0}}>
                      {formatNumberWithCommas(item?.medianSize || "1041")}
                    </span>
                  </span>
                  <span style={{ color: palette.foreground.brandPrimary }}>
                    &nbsp;sqft
                  </span>
                </Typography>
              </Box>
              <Typography className={styles.medianText}>
                Median price per sqft&nbsp;
                <span
                  style={{
                    color: palette.foreground.brandPrimary,
                    fontWeight: 600,
                  }}
                >
                  <span style={{wordBreak: "break-all", fontSize: 16, display: "inline-block", minWidth: 0}}>
                    {formatNumberWithCommas(item?.medianPricePerSqft || "1183")}
                  </span>
                </span>
                <span style={{ color: palette.foreground.brandPrimary }}>
                  &nbsp;AED/sqft
                </span>
              </Typography>
            </Box>

            <Box className={styles.adsBox}>
              <Announcement03
                width={24}
                height={24}
                stroke={palette.foreground.quinary}
                fill={palette.background.primary}
                style={{ marginRight: 4 }}
              />
              <Typography className={styles.adsText}>
                Ads number:&nbsp;
                <span
                  style={{
                    color: palette.foreground.brandPrimary,
                    fontWeight: 600,
                  }}
                >
                  <span style={{wordBreak: "break-all", fontSize: 16, display: "inline-block", minWidth: 0}}>
                    {item?.totalRows || 32}
                  </span>
                </span>
              </Typography>
            </Box>

            <Box className={styles.priceBox}>
              <Typography className={styles.priceText}>
                Median price&nbsp;
                <span
                  style={{
                    color: palette.foreground.brandPrimary,
                    fontWeight: 600,
                    fontSize: 20,
                  }}
                >
                  <span style={{wordBreak: "break-all", fontSize: 18, display: "inline-block", minWidth: 0}}>
                    {formatNumberWithCommas(item?.medianPrice || "2130129")}
                  </span>
                </span>
                <span
                  style={{
                    color: palette.utility.brand_400,
                    fontWeight: 600,
                    fontSize: 14,
                    verticalAlign: "super",
                  }}
                >
                  &nbsp;AED
                </span>
              </Typography>
            </Box>

            <Box>
              <CustomButton
                variant="outlined"
                color="secondary"
                onClick={() => handleUnitsClick(item)}
                startIcon={
                  <EyeIcon
                    width={20}
                    height={20}
                    fill={palette.button.secondary_fg}
                  />
                }
                style={{ fontWeight: 600, fontSize: 14, padding: "8px 18px" }}
              >
                View matching CRM units ({item?.numberOfUnitMatching || 248})
              </CustomButton>
            </Box>
          </Box>
        </CustomCard>
      ))}
      {isDialogOpen && (
        <MatchingCRMUnitsDialog
          onClose={() => handleClose()}
          selectedUnits={selectedUnits}
          summaryData={summaryData}
        />
      )}
    </>
  );
};

export default SummaryCard;
